<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn" [ngClass]="classes">
  {{ label }}
  <img src="assets/images/sort_z-a.png" alt="Logo" width="19" height="28" >
</button>
